;(function (W, $, D, Drupal) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D)

  const $root = $('.paragraph--type--push-blocs'),
        $sliders = $root.find('.item-wrapper'),
        prevLabel = Drupal.t('Précédent', {}, {'context' : 'accessibilite'}),
        nextLabel = Drupal.t('Suivant', {}, {'context' : 'accessibilite'})

  let pushActuFroide = (() => {

    /**
     * @function sliderInit
     * Set slider options
     */
    let sliderInit = ($slider) => {
      $slider.slick({
        appendArrows: $slider.next('.slide-controls'),
        appendDots: $slider.next('.slide-controls'),
        dots: true,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 2.1,
        label : '',
        prevArrow: '<button class="slick-prev" aria-label="'+prevLabel+'" type="button"><span class="slick-arrow-label sr-only">'+prevLabel+'</span></button>',
        nextArrow: '<button class="slick-next" aria-label="'+nextLabel+'" type="button"><span class="slick-arrow-label sr-only">'+nextLabel+'</span></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.1,
            }
          }
        ]
      }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        if(sg.viewport.isMobile() || sg.viewport.isPortrait()){
          if($slider.find('.slick-current.slick-active img') && !$slider.find('slick-current.slick-active img').hasClass('b-loaded')) {
            Drupal.blazy.init.revalidate() //reinit Lazy loading
          }
        }
      })
    },

    /**
     * @function sliderResize
     * Unslick slider on desktop
     */
    sliderResize = () => {
      if(!sg.viewport.isMobile() && !sg.viewport.isPortrait()){
        $sliders.map((i, el) => {
          let $slider = $(el)
          if($slider.hasClass('slick-initialized')){
            $slider.slick('unslick');
            $slider.find('.item').removeAttr('role')
          }
        })
      }else{
        $sliders.map((i, el) => {
          let $slider = $(el)
          if(!$slider.hasClass('slick-initialized')){
            pushActuFroide.sliderInit($slider)
            $slider.find('.item').attr('role', 'tabpanel')
          }
        })
      }
    },

    oMod = {
      sliderInit: sliderInit,
      sliderResize: sliderResize
    }

    return oMod
  })()


  $D.ready(function () {
    if(sg.viewport.isMobile() || sg.viewport.isPortrait()){
      $sliders.map((i, el) => {
        let $slider = $(el)
        pushActuFroide.sliderInit($slider)
      })
    }
  }).on('sg:viewport.resize-end', function(){
    pushActuFroide.sliderResize()
  })

})(window, window.jQuery, document, window.Drupal)
